module.exports = __webpack_public_path__ + "static/pic1-d46a93378a3030ffcbfddc4f01f88bdc.png";